import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-47579046"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item-last" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"600"} }, "How many roles are you looking to fill?", -1))
const _hoisted_3 = { class: "radio" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mr-4",
  for: "13"
}, "1 Role", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mr-4",
  for: "15"
}, "2-4 Role", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mr-4",
  for: "14"
}, " 5+ Role", -1))
const _hoisted_7 = { class: "form-item-last" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"600"} }, "What experience level are you looking for?", -1))
const _hoisted_9 = { class: "check" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "10" }, "0-2 years(Junior)", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "11" }, "2-5 years(Mid)", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "12" }, "5+ years(Senior)", -1))
const _hoisted_13 = { class: "form-item-last" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"600"} }, "Area of specialization", -1))
const _hoisted_15 = { class: "check" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "1" }, "Frontend Developer", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "2" }, "Backend Developer", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "3" }, "Full Stack Developer", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "form-text" }, "Contact information", -1))
const _hoisted_20 = { class: "form-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Full Name", -1))
const _hoisted_22 = { class: "form-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email", -1))
const _hoisted_24 = { class: "form-item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Phone Number", -1))
const _hoisted_26 = { class: "form-item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Company Name", -1))
const _hoisted_28 = { class: "form-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Specific Skills (Frameworks, Process...)", -1))
const _hoisted_30 = {
  class: "mt-3",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "hire-form",
    onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.addDevelper()), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "mr-2",
          type: "radio",
          name: "Role",
          value: "1 Role",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.developer.roles) = $event)),
          checked: "",
          id: "13"
        }, null, 512), [
          [_vModelRadio, _ctx.formData.developer.roles]
        ]),
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "mr-2",
          type: "radio",
          value: "2-4 Role",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.developer.roles) = $event)),
          name: "Role",
          id: "15"
        }, null, 512), [
          [_vModelRadio, _ctx.formData.developer.roles]
        ]),
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          class: "mr-2",
          type: "radio",
          value: "5+ Role",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.developer.roles) = $event)),
          name: "Role",
          id: "14"
        }, null, 512), [
          [_vModelRadio, _ctx.formData.developer.roles]
        ]),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "mr-2",
            name: "0-2 years(Junior)",
            value: "0-2 years(Junior)",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.developer.experience) = $event)),
            id: "10"
          }, null, 512), [
            [_vModelCheckbox, _ctx.formData.developer.experience]
          ]),
          _hoisted_10
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "mr-2",
            name: "2-5 years(Mid)",
            value: "2-5 years(Mid)",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.developer.experience) = $event)),
            id: "11"
          }, null, 512), [
            [_vModelCheckbox, _ctx.formData.developer.experience]
          ]),
          _hoisted_11
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "mr-2",
            name: "5+ years(Senior)",
            value: "5+ years(Senior)",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.developer.experience) = $event)),
            id: "12"
          }, null, 512), [
            [_vModelCheckbox, _ctx.formData.developer.experience]
          ]),
          _hoisted_12
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.experience.$errors, (error) => {
          return (_openBlock(), _createElementBlock("span", {
            key: error.$uid,
            class: "error"
          }, _toDisplayString(error.$message), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "mr-2",
            name: "Frontend Developer",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.developer.areas) = $event)),
            value: "Frontend Developer",
            id: "1"
          }, null, 512), [
            [_vModelCheckbox, _ctx.formData.developer.areas]
          ]),
          _hoisted_16
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "mr-2",
            name: "Backend Developer",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.developer.areas) = $event)),
            value: "Backend Developer",
            id: "2"
          }, null, 512), [
            [_vModelCheckbox, _ctx.formData.developer.areas]
          ]),
          _hoisted_17
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "mr-2",
            name: "Full Stack Developer",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.developer.areas) = $event)),
            value: "Full Stack Developer",
            id: "3"
          }, null, 512), [
            [_vModelCheckbox, _ctx.formData.developer.areas]
          ]),
          _hoisted_18
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.areas.$errors, (error) => {
          return (_openBlock(), _createElementBlock("span", {
            key: error.$uid,
            class: "error"
          }, _toDisplayString(error.$message), 1))
        }), 128))
      ])
    ]),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.developer.full_name) = $event)),
        placeholder: "Enter Full Name"
      }, null, 512), [
        [_vModelText, _ctx.formData.developer.full_name]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.full_name.$errors, (error) => {
        return (_openBlock(), _createElementBlock("span", {
          key: error.$uid,
          class: "error"
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _withDirectives(_createElementVNode("input", {
        type: "email",
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.developer.email) = $event)),
        placeholder: "Enter your email"
      }, null, 512), [
        [_vModelText, _ctx.formData.developer.email]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
        return (_openBlock(), _createElementBlock("span", {
          key: error.$uid,
          class: "error"
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _withDirectives(_createElementVNode("input", {
        type: "tel",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.developer.phone_num) = $event)),
        placeholder: "Enter Phone Number"
      }, null, 512), [
        [_vModelText, _ctx.formData.developer.phone_num]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.phone_num.$errors, (error) => {
        return (_openBlock(), _createElementBlock("span", {
          key: error.$uid,
          class: "error"
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.developer.company_name) = $event)),
        placeholder: "Enter your Company name"
      }, null, 512), [
        [_vModelText, _ctx.formData.developer.company_name]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.company_name.$errors, (error) => {
        return (_openBlock(), _createElementBlock("span", {
          key: error.$uid,
          class: "error"
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _withDirectives(_createElementVNode("textarea", {
        name: "message",
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.developer.message) = $event)),
        placeholder: "Enter your message"
      }, null, 512), [
        [_vModelText, _ctx.formData.developer.message]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.message.$errors, (error) => {
        return (_openBlock(), _createElementBlock("span", {
          key: error.$uid,
          class: "error"
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ]),
    _createElementVNode("button", _hoisted_30, _toDisplayString(_ctx.formData.loader), 1)
  ], 32))
}